import { render, staticRenderFns } from "./physicalSubmission.vue?vue&type=template&id=5bf6a678"
import script from "./physicalSubmission.vue?vue&type=script&lang=js"
export * from "./physicalSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports